module.exports = __webpack_public_path__ + "img/11.10.pH.72b943d8.png";